import { RESOURCES_CONSTANTS } from "config/constants";

const { RESOURCE_TYPES_IDS } = RESOURCES_CONSTANTS;

export const USE_FAKE_DATA = false;
export const FAKE_DATA = {
    RESOURCE_TYPES: [
        {
            id: "S001",
            name: "Tablets"
        },
        {
            id: "S002",
            name: "Computadoras"
        },
        {
            id: "S003",
            name: "Salas grupales"
        }
    ],
    ALL_CAMPUS: [
        {
            id: 1,
            name: "Lima Norte",
        }
    ],
    LIBRARIES: [
        {
            id: 1,
            name: "Biblioteca general",
            campusId: 1
        }
    ],
    ELECTRONIC_BRANDS: [
        {
            id: 1,
            name: "LENOVO"
        }
    ],
    SCREENS: [
        {
            id: 1,
            name: "Pantalla 1"
        }
    ],
    NEW_NAME_FOR_RESOURCE: "Recurso 1",
    RESOURCES: {
        [RESOURCE_TYPES_IDS.TABLET]: {
            total: 1,
            resources: [
                {
                    resource: {
                        id: "T0001", name: "Tablet 1", 
                        campusId: 1, libraryId: 1,
                        resourceTypeId: "S001",
                        details: "", 
                        active: true,
                        electronic: {
                            brandId: 1, 
                            serial: "X2020MI", 
                            barcode: "2020-123-4444",  
                            model: "MODEL-01"
                        },
                        groupRoom: null
                    },
                    reservations: [
                        {
                            id: 1, 
                            student: {
                                responsable: { 
                                    id: "UT2398402", 
                                    name: "Sol Quevedo"
                                },
                                others: null
                            }, 
                            schedule: {
                                date: 1667321046768,
                                timeStart: 600,
                                timeEnd: 660
                            },
                            finalized: false
                        }
                    ],
                    adminReservations: []
                }, 
                {
                    resource: {
                        id: 2, name: "Sala grupal 2", 
                        campusId: 1, libraryId: 1,
                        resourceTypeId: "S003",
                        brandId: 1, model: "MODEL-01", 
                        serial: "1001-2223-424-242", barcode: "XXX-XXX-XXX", 
                        details: "Gaaaaa", 
                        active: true
                    },
                    reservations: [
                        {
                            id: 2, 
                            student: {
                                responsable: { 
                                    id: "UT2398402", 
                                    name: "Sol Quevedo"
                                },
                                others: [
                                    {
                                        id: "UT13900402",
                                        name: "Roberto Equisde"
                                    }
                                ]
                            }, 
                            schedule: {
                                date: 1667321046768,
                                timeStart: 600,
                                timeEnd: 660
                            },
                            finalized: true
                        }
                    ],
                    adminReservations: []
                }
            ]
        }, 
        [RESOURCE_TYPES_IDS.PC]: {},
        [RESOURCE_TYPES_IDS.GROUP_ROOM]: {
            total: 2,
            resources: [
                {
                    resource: {
                        id: "SG0001", name: "Sala Grupal 2", 
                        campusId: 1, libraryId: 1,
                        resourceTypeId: "S003",
                        details: "Gaa", 
                        active: true,
                        electronic: null,
                        groupRoom: {
                            capacity: 5,
                            screenId: 1, 
                            environment: "xd",
                            address: ""
                        }
                    },
                    reservations: [
                        {
                            id: 1, 
                            student: {
                                responsable: { 
                                    id: "UT2398402", 
                                    name: "Sol Quevedo"
                                },
                                others: [
                                    {
                                        id: "UT13900402",
                                        name: "Roberto Equisde"
                                    }
                                ]
                            }, 
                            schedule: {
                                date: 1667321046768,
                                timeStart: 600,
                                timeEnd: 660
                            },
                            finalized: false
                        }
                    ],
                    adminReservations: []
                }, 
                {
                    resource: {
                        id: "SG0002", name: "Sala Grupal 2", 
                        campusId: 1, libraryId: 1,
                        resourceTypeId: "S003",
                        details: "Gaa", 
                        active: true,
                        electronic: null,
                        groupRoom: {
                            capacity: 10,
                            screenId: 1, 
                            environment: "xd2",
                            address: ""
                        }
                    },
                    reservations: [
                        {
                            id: 2, 
                            student: {
                                responsable: { 
                                    id: "UT2398402", 
                                    name: "Sol Quevedo"
                                },
                                others: []
                            }, 
                            schedule: {
                                date: 1667321046768,
                                timeStart: 600,
                                timeEnd: 660
                            },
                            finalized: false
                        }
                    ],
                    adminReservations: []
                }
            ]
        }
    }
}